import {
  CloudArrowUpIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";
import { FiArrowDownCircle } from "react-icons/fi";
import FarijiFile from "../../assets/FarijiFile.pdf";

export default function Fariji() {
  return (
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <svg
          className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="e813992c-7d03-4cc4-a2bd-151760b470a0"
              width={200}
              height={200}
              x="50%"
              y={-1}
              patternUnits="userSpaceOnUse"
            >
              <path d="M100 200V.5M.5 .5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
            <path
              d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect
            width="100%"
            height="100%"
            strokeWidth={0}
            fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)"
          />
        </svg>
      </div>
      <div className="mx-auto grid max-w-2xl  gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:items-start lg:gap-y-10">
        <div className=" lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">
                Funeral Plans
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Fariji Funeral Cover
              </h1>
            </div>
          </div>
        </div>

        <div className=" lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className=" text-base leading-7 text-gray-700 ">
              <p>
                Fariji Plan is a funeral plan from Britam that will help your
                family cater for your funeral expenses in the event of your
                death and give them peace of mind when they need it most.
              </p>
              <p>
                Funeral plan provides protection cover only. Premiums are paid
                throughout the life of the insured with benefits including that
                the sum assured is applicable to each family member, no limit on
                the number and the maximum insured age is 82 years.
              </p>
              <div className="flex gap-x-4 items-center ">
                <a
                  href={FarijiFile}
                  download={FarijiFile}
                  className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                  aria-label="Download Resume"
                >
                  <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                  <span className="text-sm sm:text-lg font-general-medium duration-100">
                    Product Brochure
                  </span>
                </a>
              </div>

              <h5 className="pt-8">
                <strong>How does it work?</strong>
              </h5>
              <p>
                Anyone who meets the eligibility criteria can purchase cash
                benefit from as low as Kshs 100,000 up to a maximum of Kshs
                500,000.
              </p>
              <h5 className="pt-8">
                <strong>Some of the benefits include:</strong>
              </h5>
              <ul className="list-disc list-inside">
                <li>
                  50% of the cash benefit is paid within 72 hours of
                  notification to Britam though a burial permit and the 50% upon
                  submission of death certificate.
                </li>
                <li>No medical examinations are required.</li>
                <li>
                  Cash benefit and premium payable are guaranteed up to your
                  75th birthday.
                </li>
                <li>
                  The cash benefit is paid to your beneficiary and they have
                  discretion on how it will be utilized.
                </li>
              </ul>
              <div className="pt-8">
                <table>
                  <thead>
                    <tr>
                      <th>Entry Age</th>
                      <th className="px-8">Sum Assured</th>
                      <th>Monthly Premium</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <b>Tier1</b>
                      </td>
                      <td className="px-8">
                        <b>Kshs</b>
                      </td>
                      <td>
                        <b>Kshs</b>
                      </td>
                    </tr>
                    <tr>
                      <td>35</td>
                      <td className="px-8">100,000</td>
                      <td>160</td>
                    </tr>
                    <tr>
                      <td>45</td>
                      <td className="px-8">100,000</td>
                      <td>204</td>
                    </tr>
                    <tr>
                      <td>55</td>
                      <td className="px-8">100,000</td>
                      <td>274</td>
                    </tr>
                    <tr>
                      <td>
                        <b>Tier2</b>
                      </td>
                      <td className="px-8">
                        <b>Kshs</b>
                      </td>
                      <td>
                        <b>Kshs</b>
                      </td>
                    </tr>
                    <tr>
                      <td>35</td>
                      <td className="px-8">250,000</td>
                      <td>400</td>
                    </tr>
                    <tr>
                      <td>45</td>
                      <td className="px-8">250,000</td>
                      <td>510</td>
                    </tr>
                    <tr>
                      <td>55</td>
                      <td className="px-8">250,000</td>
                      <td>685</td>
                    </tr>
                    <tr>
                      <td>
                        <b>Tier3</b>
                      </td>
                      <td className="px-8">
                        <b>Kshs</b>
                      </td>
                      <td>
                        <b>Kshs</b>
                      </td>
                    </tr>
                    <tr>
                      <td>35</td>
                      <td className="px-8">500,000</td>
                      <td>800</td>
                    </tr>
                    <tr>
                      <td>45</td>
                      <td className="px-8">500,000</td>
                      <td>1020</td>
                    </tr>
                    <tr>
                      <td>55</td>
                      <td className="px-8">500,000</td>
                      <td>1370</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto grid max-w-2xl mt-20 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:items-start lg:gap-y-10">
        <div className=" lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">
                Funeral Plans
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Britam Funeral Cover
              </h1>
            </div>
          </div>
        </div>

        <div className=" lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className=" text-base leading-7 text-gray-700 ">
              <p>
                The Funeral Plan insurance is a product sold to families to
                cater for the funeral expenses in the event of death of a family
                member.
              </p>
              <p>
                Members of the covered group can include only members of a
                nuclear family (spouse and children including the legally
                adopted) and the biological parents of both spouses below age 75
                years.
              </p>
              <p>
                Extended family members like brothers, sisters, grandparents
                etc. are not covered.
              </p>
              <p>
                Individuals who may want to buy should be ready to pay the
                minimum premium for any option. One can also buy for less than 4
                but again pay the minimum for any option.
              </p>
              <h5 className="pt-8">
                <strong>Product Features</strong>
              </h5>
              <ul className="list-disc list-inside">
                <li>
                  The funeral plan is sold to a family at least 4 lives assured
                  as a stand-alone product.
                </li>
                <li>
                  Issue ages: Minimum is 18 years. Maximum 65 years at entry for
                  the primary covered.
                </li>
                <li>
                  School-going children up to the age of 23 may also be covered.
                </li>
                <li>Maximum age on cover is limited to 82 years.</li>
                <li>
                  Minimum premium: Kshs.770 -Maximum depends on the size of the
                  family and option purchased.
                </li>
                <li>
                  Benefit (Sum assured): Minimum Kshs.150,000- Maximum
                  Kshs.500,000
                </li>
                <li>Term - No minimum or maximum term</li>
                <li>There is no medical examination for the product.</li>
                <li>
                  Premiums may be payable at various frequencies i.e. monthly,
                  quarterly, semi-annually, annually.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
